import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, OnInit } from '@angular/core';
import { UxAppShellService } from '@eui/core';

@Component({
    selector: 'eui-app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./_styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiAppToolbarComponent implements OnInit {
    @HostBinding('class') string = 'eui-app-toolbar';
    @HostBinding('attr.role') role = 'banner';

    constructor(
        public asService: UxAppShellService,
    ) {
    }

    ngOnInit() {
        this.asService.activateToolbar();
    }
}
